module.exports = __webpack_public_path__ + "media/flags/sx-9d5dd5f9.svg";